import React from 'react'
import {
  Grid,  Typography } from '@mui/material'
import { map } from '@/utils/lodash'

const ConstructionLoanForm = ({
  constructionLoanFields,
  renderInputFields }) => (
  <>
    <Grid container>
      <Grid size={12}>
        <Typography variant="h6">Construction Loan</Typography>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={1}>
      {map(constructionLoanFields, (field) =>
        renderInputFields(false)(field),
      )}
    </Grid>
  </>
)

export default ConstructionLoanForm
